<template>
  <div>
    <div class="container">
      <h2 class="font-weight-bold font-size-medium text-center">Trocar senha</h2>
      <p class="text-center">Digite o email utilizado para cadastro na plataforma</p>

      <div class="col-md-6 mx-md-auto">
        <form
          class="default-form my-5"
          action=""
          method="POST"
          @submit.prevent="submit"
        >
          <DefaultInput
            type="email"
            label="Endereço de email"
            v-model="$v.form.email.$model"
          />

          <div class="text-center mt-5">
            <Button
              class="btn-primary btn-lg"
              :loading="loader"
              :disabled="$v.$invalid"
              @click="submit"
            >
              Enviar email
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required, email } from 'vuelidate/lib/validators'

import Button from '@/components/common/Button/Button.vue'
import DefaultInput from '@/components/common/Input/DefaultInput.vue'

export default {
  components: {
    Button,
    DefaultInput
  },
  data () {
    return {
      form: {
        email: ''
      },
      loader: false
    }
  },
  metaInfo () {
    return {
      title: 'Trocar senha'
    }
  },
  validations () {
    return {
      form: {
        email: { required, email }
      }
    }
  },
  methods: {
    async submit () {
      this.loader = true
      try {
        await AuthService.sendResetPasswordEmail(this.form.email)
        const notification = {
          notification: {
            type: 'success',
            content: 'Enviamos um email com as instruções para troca de senha'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.form.email = ''
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
